import CongratulationsSection from '../CongratulationsSection';
import PolicyInformationSection from '../PolicyInformationSection';

const NewPolicyPage1Pluss = ({ data }) => {
  return (
    <>
      <h1>
        Helseforsikring
        <br />
        Forsikringsbevis - Pluss
      </h1>
      <PolicyInformationSection data={data} />
      <CongratulationsSection />
    </>
  );
};

export default NewPolicyPage1Pluss;
